import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace} from '../../common/utils';
import _route from '../../common/utils/route';

var _createNamespace = createNamespace('cell'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

import MaiIcon from '../icon';
export default {
    name: getComponentName('Cell'),
    data: function data() {
        return {};
    },
    props: {
        icon: String,
        size: String,
        isLink: Boolean,
        titleClass: null,
        valueClass: null,
        title: [Number, String],
        value: [Number, String],
        arrowSize: [Number, String],
        borderLess: {
            type: Boolean,
            default: false
        },
        url: String,
        replace: Boolean,
        to: [String, Object]
    },
    computed: {
        classes: function classes() {
            var size = this.size,
                borderLess = this.borderLess;
            var arr = [];
            size && arr.push(size);
            borderLess && arr.push('borderless');
            return [b(arr)];
        }
    },
    methods: {
        onClick: function onClick() {
            _route.functionalRoute(this);

            this.$emit('click');
        },
        LeftIcon: function LeftIcon() {
            var h = this.$createElement;
            var icon = this.icon;
            var slot = this.$slots.icon;

            if (slot) {
                return slot;
            }

            if (icon) {
                return h('mai-icon', {
                    class: b('left-icon'),
                    attrs: {
                        name: icon
                    }
                });
            }
        },
        Title: function Title() {
            var h = this.$createElement;
            var title = this.title,
                titleClass = this.titleClass;
            var slot = this.$slots.title;
            var classArr = [b('title'), titleClass];

            if (slot) {
                return slot;
            }

            if (title) {
                return h(
                    'div',
                    {
                        class: classArr
                    },
                    [h('span', [this.title])]
                );
            }
        },
        Value: function Value() {
            var h = this.$createElement;
            var value = this.value,
                title = this.title,
                valueClass = this.valueClass;
            var showTitle = this.$slots.title || title;
            var slot = this.$slots.default;
            var classArr = [
                b('value', {
                    alone: !showTitle
                }),
                valueClass
            ];

            if (slot) {
                return slot;
            }

            if (value) {
                return h(
                    'div',
                    {
                        class: classArr
                    },
                    [h('span', [value])]
                );
            }
        },
        RightIcon: function RightIcon() {
            var h = this.$createElement;
            var isLink = this.isLink,
                arrowSize = this.arrowSize;
            var slot = this.$slots.rightIcon;

            if (slot) {
                return slot;
            }

            if (isLink) {
                return h('mai-icon', {
                    class: b('right-icon'),
                    attrs: {
                        name: 'arr-right',
                        size: arrowSize
                    }
                });
            }
        }
    },
    render: function render() {
        var h = arguments[0];
        var classes = this.classes,
            LeftIcon = this.LeftIcon,
            Title = this.Title,
            Value = this.Value,
            RightIcon = this.RightIcon;
        return h(
            'div',
            {
                class: classes,
                on: {
                    click: this.onClick
                }
            },
            [LeftIcon(), Title(), Value(), RightIcon()]
        );
    },
    components: {
        MaiIcon: MaiIcon
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
